import queryString from 'query-string';
import _, { has } from 'lodash';
import appConfig from '../appConfig';
import { showExternalAsMain, showSearchAsMain, showAdminAsMain } from '../actions/mainUI';
import piction, { createTemplateURL, getLanguageFromLocale } from './piction';
import { validateSessionConnection } from '../actions/session';
import appConfigLocal from '../appConfig';

// eslint-disable-next-line no-undef
const pathPrefix = __DEV__ ? '../' : './';

export const allowDropHandler = (e) => {
  e.preventDefault();
};

export const getUrlVars = () => {
  const vars = [];
  let hash;
  const hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for (let i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = decodeURIComponent(hash[1]);
  }
  vars.surl = sessionStorage.getItem('surl') || '';
  vars.token = sessionStorage.getItem('token');
  vars.locale = sessionStorage.getItem('locale');

  return vars;
};

export const launchWindow = (url, dispatch, overrideConfig = {}) => {
  const surl = piction.session.surl;
  dispatch(validateSessionConnection(surl))
    .then((res) => {
      if (res.isValid) {
        const defaultConfig = {
          width: 1080,
          height: 800,
          toolbar: 'no',
          location: 'no',
          menubar: 'no',
          scrollbars: 'yes',
          resizable: 'no',
        };
        const config = { ...defaultConfig, ...overrideConfig };
        const configAsArray = Object.keys(config).map(prop => `${prop}=${config[prop]}`);
        return window.open(url, '_blank', configAsArray.join(','));
      }
      return null;
    });
};

export const openExternalLink = (url, openInCurTab = false) => window.open(url, openInCurTab ? '_self' : '_blank');

/* downloads a given URL
 * @param fileURL - downloadable url
 * @param fieName - fileName to prompt
 */
export const downloadFile = (fileURL, fileName) => {
  const save = document.createElement('a');
  save.href = fileURL;
  const filename = fileURL.substring(fileURL.lastIndexOf('/') + 1);
  save.download = fileName || filename;
  if (navigator.msSaveBlob) { // for IE < 11
    document.body.appendChild(save);
    save.click();
  } else {
    save.target = '_blank';
    if (navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/)
        && navigator.userAgent.search('Chrome') < 0) {
      document.location = save.href;
    } else { // window event not working here
      const evt = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: false,
      });
      save.dispatchEvent(evt);
      (window.URL || window.webkitURL).revokeObjectURL(save.href);
    }
  }
};

export const downloadExportFile = (url, isExt = false) => {
  // creating a form to open new window with POST action
  const form = document.createElement('form');
  form.setAttribute('method', 'post');
  form.setAttribute('action', url);
  if (navigator.msSaveBlob && !isExt) { // for IE
    form.setAttribute('target', '_self');
  } else {
    form.setAttribute('target', '_blank');
  }

  // put the params as hidden input fields- for security purposes
  const hiddenField = document.createElement('input');
  hiddenField.setAttribute('type', 'hidden');
  hiddenField.setAttribute('name', 'surl');
  hiddenField.setAttribute('value', piction.session._surl || '');
  form.appendChild(hiddenField);
  const hiddenField2 = document.createElement('input');
  hiddenField2.setAttribute('type', 'hidden');
  hiddenField2.setAttribute('name', 'csrf');
  hiddenField2.setAttribute('value', piction.session._token);
  form.appendChild(hiddenField2);

  // Append and submit
  document.body.appendChild(form);

    // eslint-disable-next-line no-underscore-dangle
    // const _window = window.open('', '_blank');
  form.submit();
    // _window.close();
    // const _window = window.open(fileURL, '_blank');
  //   _window.document.close();
  //   _window.document.execCommand('SaveAs', true,'download');
  //   _window.close();
  // } else {
  //   form.submit();
  // }
};

export const createBasketUrl = (templateName, params, locale) => {
  let paramsQueryString = `${_.map(params, value => (_.isArray(Object.values(value)[0]) ?
    Object.values(value)[0].map(valID => `${Object.keys(value)[0]}=${valID}`).join('&') :
    `${Object.keys(value)[0]}=${Object.values(value)[0]}`)).join('&')}`;

  if (locale && getLanguageFromLocale(locale)) {
    paramsQueryString += `&LANGUAGE=${getLanguageFromLocale(locale)}`;
  }
  return `${appConfigLocal.hostURL}!tpl.private_page?&acid=&name=${templateName}&${paramsQueryString}`;
};

export const showBasket = (dispatch, workspaceID, umoList, isSelectAll, locale) => {
  const surl = piction.session.surl;
  const params = [];
  if (isSelectAll) {
    params.push({ LIGHTBOX_ID: workspaceID });
  }
  if (umoList) {
    params.push({ UMO_IDS: umoList.map(umoID => `${umoID}`).join(',') });
  }

  dispatch(showExternalAsMain(
  createBasketUrl(appConfig.templates.basket.name, params, locale),
    surl
  ));
};

export const showPhotoBasket = (dispatch, workspaceID, umoList, isSelectAll, locale) => {
  const surl = piction.session.surl;
  const params = [];
  if (isSelectAll) {
    params.push({ LIGHTBOX_ID: workspaceID });
  }
  if (umoList) {
    params.push({ UMO_IDS: umoList.map(umoID => `${umoID}`).join(',') });
  }

  dispatch(showExternalAsMain(
    createBasketUrl(appConfig.templates.photoBasket.name, params, locale),
    surl
  ));
};

export const showAuthWorkflowTemplate = (dispatch, locale) => {
  const surl = piction.session.surl;
  dispatch(showExternalAsMain(
  createTemplateURL(appConfig.templates.authoriseWorkflow.name, undefined, locale),
    surl
  ));
};

export const showWorkflowDashTemplate = (dispatch, locale) => {
  const surl = piction.session.surl;
  dispatch(showExternalAsMain(
    createTemplateURL(appConfig.templates.workflowDashboard.name, undefined, locale),
    surl
  ));
};

export const showUploadTemplate = (dispatch, categoryID, categoryName) => {
  const params = {
    categoryID,
    categoryName,
  };
  sessionStorage.setItem('destination', appConfigLocal.hostURL);
  const url = appConfig.userOldLoader ?
    `${pathPrefix}external-tools/category-upload/index.html?` :
    `${pathPrefix}external-tools/category-uploader/index.html?`;
  if (dispatch) {
    dispatch(showAdminAsMain(`${url}${queryString.stringify(params)}`, piction.session.surl));
  }
};

export const showWorkspaceLoader = (dispatch, workspaceID) => {
  dispatch(showExternalAsMain(
    createTemplateURL(appConfig.templates.workspaceUpload.name, { LIGHTBOX_ID: workspaceID })
  ));
};

export const showManageCatRolesScreen = (dispatch, editable) => {
  const params = {
    edit: editable,
  };

  const url = `${pathPrefix}external-tools/category-roles/index.html?`;

  if (dispatch) {
    dispatch(showAdminAsMain(`${url}${queryString.stringify(params)}`, piction.session.surl));
  } else {
    downloadExportFile(`${url}${queryString.stringify(params)}`, true);
  }
};

export const showSearch = (dispatch) => {
  dispatch(showSearchAsMain());
};

export const showCropTool = (umo, dispatch) => {
  const params = {
    id: umo.id,
  };

  downloadExportFile(
    `${pathPrefix}external-tools/image-cropper/index.html?${queryString.stringify(params)}`,
    true
  );
};

export const showUsersAndRolesScreen = (dispatch) => {
  const url = `${pathPrefix}external-tools/users-and-roles/index.html?`;

  if (dispatch) {
    dispatch(showAdminAsMain(url, piction.session.surl));
  } else {
    launchWindow(url, dispatch);
  }
};

export const showImageResizeTool = (umo, locale, dispatch) => {
  const surl = piction.session.surl;
  const params = {
    xpk: umo.id,
    acid: '',
    start_from: '1',
    vworkvar: 'U',
  };

  let language = getLanguageFromLocale(locale);

  if (language) {
    language = `&LANGUAGE=${language}`;
  } else {
    language = '';
  }

  downloadExportFile(
    `${piction.hostURL}cst.dynamic_resize?${queryString.stringify(params)}${language}`,
    true
  );
};

export const showVideoAnnotatorTool = (umo, dispatch) => {
  const params = { umoid: umo.id };

  launchWindow(
    `${pathPrefix}external-tools/video-annotator/index.html?${queryString.stringify(params)}`,
    dispatch
  );
};

export const showVideoTrimmerTool = (umo, dispatch) => {
  const params = {
    u: umo.id,
    type: 'share',
  };

  launchWindow(
    `${pathPrefix}external-tools/video-trimmer/index.html?${queryString.stringify(params)}`,
    dispatch
  );
};

export const showMetaEditTool = (umo, dispatch) => {
  const url = `${pathPrefix}external-tools/meta-edit/index.html?`;
  const surl = piction.session.surl;
  const params = {};

  if (!umo) {
    params.type = 'mass-edit';
    dispatch(showAdminAsMain(`${url}${queryString.stringify(params)}`, surl));
  } else {
    params.umoid = umo.id;
    launchWindow(`${url}${queryString.stringify(params)}`, dispatch);
  }
};

export const showNewRecordTool = (dispatch) => {
  const url = `${pathPrefix}external-tools/relational-tool/index.html`;

  launchWindow(url, dispatch);
};

export const showImageAnnotatorTool = (umo, dispatch) => {
  const url = `${pathPrefix}external-tools/image-annotator/index.html?`;
  const params = {
    umoid: umo.id,
  };

  launchWindow(`${url}${queryString.stringify(params)}`, dispatch, { width: 1400, height: 900 });
};

export const showUmoExternalLink = (dispatch, link, umoID, params) => {
  const p = { umoID, ...params };
  const url = `${link}?${queryString.stringify(p)}`;
  dispatch(showAdminAsMain(url, piction.session.surl));
};

export const getLabelFromAppConfig = (configData = {}, locale, labelKey = 'label') => {
  const labelLocaleKey = `${labelKey}Locale`;
  if (locale && has(configData, [labelLocaleKey, locale])) {
    return configData[labelLocaleKey][locale];
  }

  return configData[labelKey];
};

export const reportImage = (dispatch, umoID, umoName, locale) => {
  downloadExportFile(
    createTemplateURL(
      _.isString(appConfig.reportImage) ? appConfig.reportImage : 'KAUI2.Report_Image',
      { INTERNAL_PK: umoID, IMAGE_NAME: umoName }, locale),
    true);
};

export const disableRightClick = (e) => {
  if (appConfig.disableRightClick) {
    e.preventDefault();
    return false;
  }
  return true;
};



// WEBPACK FOOTER //
// ./src/js/utils/uiUtils.js